import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { SubscriptionPlans } from './components/SubscriptionPlans';
import { AddOns } from './components/AddOns';
import { Pricing } from './components/Pricing';
import { Benefits } from './components/Benefits';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <SubscriptionPlans data-id="element-5" />
        <AddOns data-id="element-6" />
        <Pricing data-id="element-7" />
        <Benefits data-id="element-8" />
        <FAQ data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}